// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"2059172bbdc2aff3","5763":"66130ab9a2227ed4","6893":"e1aff9969149b80a","6974":"9f8b119d22e66aef","7222":"03347c77dcc16dbc","7937":"bfd7958b7a047a15"}[chunkId] + ".js";
};